import { NgModule, ModuleWithProviders } from '@angular/core'
import { CommonModule } from '@angular/common'

import { UltimateGuideRoutingModule } from './ultimateguide-routing.module'
import { CoreModule } from '../../core.module'

import { CustomTranslateModule } from '@flowaccount/landing'
import { UltimateGuideComponent } from './ultimateguide/ultimateguide.component'
import { GuidePageComponent } from './guide-page/guide-page.component'
import { ScullyLibModule } from '@scullyio/ng-lib'
import { GuideContentComponent } from './guide-content/guide-content.component'
import { GuideTableComponent } from './guide-table/guide-table.component'
import { GuideBreadcrumbsComponent } from './guide-breadcrumbs/guide-breadcrumbs.component'
import { GuideFooterComponent } from './guide-footer/guide-footer.component'
import { StarterKitComponent } from './ultimateguide/starter-kit/starter-kit.component'
import { ReactiveFormsModule } from '@angular/forms'
import { BsModalRef, BsModalService, ModalModule } from 'ngx-bootstrap/modal'
import { BookComponent } from './ultimateguide/starter-kit/book/book.component'
import { SWIPER_CONFIG, SwiperConfigInterface } from 'ngx-swiper-wrapper'
// swiper
const DEFAULT_SWIPER_CONFIG: SwiperConfigInterface = {
  direction: 'horizontal',
  slidesPerView: 'auto',
  loop: false,
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
    hideOnClick: true,
  },
}
@NgModule({
  declarations: [
    UltimateGuideComponent,
    GuidePageComponent,
    GuideContentComponent,
    GuideTableComponent,
    GuideBreadcrumbsComponent,
    GuideFooterComponent,
    StarterKitComponent,
    BookComponent,
  ],
  imports: [
    CommonModule,
    ScullyLibModule,
    CoreModule.forRoot(),
    UltimateGuideRoutingModule,
    ReactiveFormsModule,
    CustomTranslateModule.forChild({ path: 'ultimateguide' }),
    ModalModule.forRoot(),
  ],
  providers: [
    BsModalService,
    BsModalRef,
    {
      provide: SWIPER_CONFIG,
      useValue: DEFAULT_SWIPER_CONFIG,
    },
  ],
})
export class UltimateGuideModule {}
